<div class="overflow-hidden" [ngClass]="getSizeClass()">
  <div class="iac-spinner-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
